import React, { useState } from "react";
import { Box, Card, Typography, CardContent, Grid, Divider } from "@material-ui/core";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { useStyles } from "./style";
import TabHeader from "src/components/TabHeader/TabHeader";
import CommonButton from "src/components/CommonButton/CommonButton";
import CameraIcon from "@material-ui/icons/CameraAlt";
import { HeadQuarterRoute } from "../../head-quarter.routes";

interface Props {}

export default function CameraStream({}: Props): React.ReactElement {
  const classes = useStyles();
  const [moduleName] = useState<any>(HeadQuarterRoute.title);
  const [pageHeading] = useState<any>("Camera Stream");

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  // let gridMaxHeight = 0;
  // let dppr = 10;
  wHeight = height - 132;
  // gridMaxHeight = height - 200;
  // if (height > 700 && height < 900) {
  //   dppr = 15;
  // } else if (height > 900) {
  //   dppr = 25;
  // } else {
  //   dppr = 10;
  // }

  const openCameraStream = () => {
    window.open(
      process.env.REACT_APP_CAMERA_URL,
      "_blank",
      "width=1300,height=600,left=150,top=100"
    );
  };

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: wHeight }}>
          <Grid container direction="row" justify="space-between" alignItems="center">
            <Grid item md={8}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}>{pageHeading}</Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider />
          <Grid container direction="row" justify="space-between" alignItems="center">
            <Grid item md={12}>
              <Box marginTop={20} textAlign={"center"}>
                <CommonButton cssClass="customSubmitBtn" isGreen onClick={() => openCameraStream()}>
                  <CameraIcon /> <span style={{ marginLeft: "10px" }}>Camera Stream</span>
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
